export default {
  title: {
    en: 'Discover a complete catalogue of products',
  },
  buttonTitle: {
    en: 'Go to the catalog',
  },
}
